import React from 'react';
import { Home} from '../components/index';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Acces from '../components/acces/Acces';
import Introduction from '../components/Introduction/Introduction';
import Formulaires from '../components/Formulaires/Formulaire';
import Visitevirtuelle from '../components/visitevirtuelle/visitevirtuelle';
import Contact from '../components/Container/Contact';
import Organigramme from '../components/organigramme/organigramme';
import Calandrier from '../components/calendrier/calendrier';
import Departementinfo from '../components/departement/departementinfo.js';
import Departementmath from '../components/departement/departementmath.js';
import DepartementT from '../components/departement/departementT.js';
import ToutesActualités from '../components/Actualites/ToutesActualites';
import Actualité1 from '../components/Actualites/Actualite1';
import Transport1 from '../components/Transport1/Transport1';
import Club from '../components/club/club';
import Ingenieurie from '../components/ingenieur/ingenieur';
import Licence from '../components/licence/licence';
import Mastère from '../components/master/master';
import Prepa from '../components/prepa/prepa';
import Enseignant from '../components/Enseignant/Enseignant';
import Formstage from '../components/formstage/formstage';
import Formoffre from '../components/formstage/formeoffre';
import Sport from '../components/Sport/sport';

import Documents from '../components/Manuelle des documents Administrative/Documents.jsx';
import LazharHamel from '../components/Enseignant/LazharHamel.jsx';
import Administration from '../components/Administration/Administration.jsx'
import Espaceetudiant from '../components/espaceetudiant/espaceetudiant';
import DashbordEtudiant from '../components/espaceetudiant/DashbordEtudiant.jsx';
import ActualitéEtudiant from '../components/espaceetudiant/actualitéetudiant.jsx';







function Pages() {
  return (
    <>
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/Acces" element={<Acces/>} />
          <Route path="/Introduction" element={<Introduction/>} />
          <Route path="/Formulaires" element={< Formulaires/>} />
          <Route path="/visitevirtuelle" element={<Visitevirtuelle/>} />
          <Route path="/contact" element={<Contact/>} />
          <Route path="/Organigramme" element={<Organigramme/>} />
          <Route path="/calendrier" element={<Calandrier/>} />
          <Route path="/departementInfo" element={<Departementinfo/>} />
          <Route path="/departementM" element={<Departementmath/>} />
          <Route path="/departementT" element={<DepartementT/>} />
          <Route path="/ToutesActualités" element={<ToutesActualités/>} />
          <Route path="/Actualité1" element={<Actualité1/>} />
          <Route path="/Transport1" element={<Transport1/>} />
          <Route path="/Club" element={<Club/>} />
          <Route path="/Ingenieurie" element={<Ingenieurie/>} />
          <Route path="/licence" element={<Licence/>} />
          <Route path="/Mastère" element={<Mastère/>} />
          <Route path="/Prepa" element={<Prepa/>} />
          <Route path="/Enseignant" element={<Enseignant/>} />
          <Route path="/Formstage" element={<Formstage/>} />
          <Route path="/Formoffre" element={<Formoffre/>} />
          <Route path="/Sport" element={<Sport/>} />

          <Route path="/Documents" element={<Documents/>} />
          <Route path='/Lazhar hamel' element={<LazharHamel/>}/>
          <Route path="/Administration" element={<Administration/>}/>
          <Route path="/Espaceetudiant" element={<Espaceetudiant/>} />
          
          <Route path="/DashbordEtudiant/:uid" element={<DashbordEtudiant/>} />
          <Route path="/ActualitéEtudiant" element={<ActualitéEtudiant/>} />
          

          




                    

          
          
          
          

          

         
        </Routes>
      </Router>
    </>
  );
}

export default Pages;
